/**
 * Libs
 */

/**
 * Constants
 */
import { speed } from 'src/ui/common/config/animations';
import styled, { css } from 'styled-components';

export const StyledFaqCategoriesMenu = styled.div`
    position: sticky;
    top: 96px;
    min-width: 350px;
    background: linear-gradient(110deg, ${({ theme }) => theme.colors.softPurple} 40%, rgba(0, 0, 0, 0) 20%),
        radial-gradient(
            farthest-corner at 0% 0%,
            ${({ theme }) => theme.colors.softBlue} 70%,
            ${({ theme }) => theme.colors.softTurtle} 70%
        );

    h3 {
        margin-bottom: 32px;
    }

    ul {
        list-style-type: none;
    }
`;

export const StyledFaqCategoryLink = styled.a<{
    active: boolean;
}>`
    display: block;
    padding: 15px 10px;
    transition: background-color ${speed.content} ease-in-out;
    border-bottom: 4px solid ${({ theme }) => theme.colors.white};

    ${({ active }) =>
        active &&
        css`
            background-color: ${({ theme }) => theme.colors.blue};

            & span {
                color: ${({ theme }) => theme.colors.white};
            }
        `}

    &:hover {
        background-color: ${({ theme }) => theme.colors.deepBlue};

        & span {
            color: ${({ theme }) => theme.colors.white};
        }
    }
`;
